import userAuthService from './user-auth-service';
import userAuthApi from './user-auth-api';
import c2bOmsService from './c2b-oms-service';
import c2bOmsApi from './c2b-oms-api';
import c2bListingService from './c2b-listing-service';
import c2bListingApi from './c2b-listing-api';
import c2bAuctionAEService from './c2b-auction-ae-service';
import c2bAuctionAEApi from './c2b-auction-ae-api';
import userProfileMeService from './user-profile-service';
import userProfileMeApi from './user-profile-api';
import c24UserService from './c24-user-service';
import c24UserApi from './c24-user-api';
import c2bNotificationService from './c2b-notification-service';
import c2bNotificationApi from './c2b-notification-api';

const authService = userAuthService(userAuthApi);
const c2bOmsBaseService = c2bOmsService(c2bOmsApi);
const c2bListingBaseService = c2bListingService(c2bListingApi);
const c2bAuctionAEBaseService = c2bAuctionAEService(c2bAuctionAEApi);
const userProfileMeBaseService = userProfileMeService(userProfileMeApi);
const c24UserBaseService = c24UserService(c24UserApi);
const c2bNotificationBaseService = c2bNotificationService(c2bNotificationApi);

export {
    authService as AuthService,
    c2bOmsBaseService as C2bOmsService,
    c2bListingBaseService as C2bListingService,
    c2bAuctionAEBaseService as C2bAuctionAEService,
    userProfileMeBaseService as UserProfileMeService,
    c24UserBaseService as C24UserService,
    c2bNotificationBaseService as C2bNotificationService
};
